module.exports = __webpack_public_path__ + "static/media/IMG_3591.ed118790.jpg";